'use client';

export { AddToCart, type AddToCartProps } from './ui/add-to-cart';
